{
    "LicenseManagement_Title": "Gestão de licenças empresariais",
    "LicenseManagement_Heading_License": "Licença - Equipas",
    "LicenseManagement_Heading_Quantity": "Quantidade",
    "LicenseManagement_Essentials": "Essenciais",
    "LicenseManagement_Essentials_MST": "Norma CXA",
    "LicenseManagement_Professional": "Profissional",
    "LicenseManagement_Professional_MST": "CXA Premium",
    "LicenseManagement_Enterprise": "Empresa",
    "LicenseManagement_Enterprise_MST": "CXA Avançado (Histórico)",
    "LicenseManagement_CallCentreAgent": "Agente do Call Center",
    "LicenseManagement_CallCentreAgent_MST": "CXA Premium",
    "LicenseManagement_CallCentreSupervisor": "Supervisor do Call Center",
    "LicenseManagement_CallCentreSupervisor_MST": "CXA Avançado",
    "LicenseManagement_Validation_Number": "Deve ser um número válido",
    "LicenseManagement_Validation_Limit": "Excede o limite da licença CME. Deve ser inferior ou igual a {}",
    "LicenseManagement_Validation_Limit_Reached": "Excede o limite máximo da licença CME. Não há mais licenças disponíveis",
    "LicenseManagement_Validation_MAX_LIMIT": "O número excede o número máximo permitido",
    "LicenseManagement_Validation_POSITIVE_NUMBER": "O número deve ser positivo",
    "NAME": "LicenseManagement",
    "LicenseManagement_CXIntegration": "Integração CX",
    "LicenseManagement_Essentials_WBX": "Usuário WxC",
    "LicenseManagement_Essentials_MSTB": "Usuário histórico",
    "LicenseManagement_Professional_WBX": "Profissional",
    "LicenseManagement_Professional_MSTB": "Usuário em tempo real",
    "LicenseManagement_Enterprise_WBX": "Empresa",
    "LicenseManagement_Enterprise_MSTB": "Empresa",
    "LicenseManagement_CallCentreAgent_WBX": "Agente WxC",
    "LicenseManagement_CallCentreAgent_MSTB": "Agente",
    "LicenseManagement_CallCentreSupervisor_WBX": "Supervisor WxC",
    "LicenseManagement_CallCentreSupervisor_MSTB": "Gerente"
}